export enum typeSocial {
  instagram = "Instagram",
  twitter = "Twitter",
  discord = "Discord",
}
